module.exports = __webpack_public_path__ + "img/entrada.a463cfaf.svg";